import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';
import { useOpenDeeplink } from '../../../../hooks';

export const useMoveToFragmentScreens = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (screenName: string, extraParams?: Record<string, unknown>) => {
      const getDeeplink = () => {
        const url = getDefaultDeeplink();
        appendParams(url, 'screen', 'FragmentScreens');
        return url;
      };
      const extras = {
        screen_name: screenName,
        ...(extraParams ? extraParams : {}),
      };
      const goodsDetailDeeplink = getDeeplink();
      appendParams(goodsDetailDeeplink, 'extras', JSON.stringify(extras));

      return openDeeplink(finalizeUrl(goodsDetailDeeplink));
    },
    [openDeeplink],
  );
};
